import React, { ReactNode } from "react";
import { BaseToastStyle as S } from "./BaseToast.style";

export const BaseToast: React.FC<{
  icon?: ReactNode;
  headerText?: ReactNode;
  subText?: ReactNode;
  content?: ReactNode;
}> = ({ icon, headerText, subText, content }) => {
  return (
    <S.Toast>
      <S.Header>
        {icon}
        <S.HeaderText>{headerText}</S.HeaderText>
      </S.Header>
      {content || <S.SubText>{subText}</S.SubText>}
    </S.Toast>
  );
};
